export interface SocialMediaProps {
  x?: string;
  linkedin?: string;
  instagram?: string;
  github?: string;
  website?: string;
}

export enum SocialMediaTypes {
  X = 'x',
  LINKEDIN = 'linkedin',
  INSTAGRAM = 'instagram',
  GITHUB = 'github',
  WEBSITE = 'website',
}
